import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AnabizPaymentInputApproverListComponent } from '@app/anabiz-payment-input/modal/anabiz-payment-input-approver-list/anabiz-payment-input-approver-list.component';
import { defaultApproverListModalParts } from '@app/anabiz-payment-input/modal/anabiz-payment-input-approver-list/anabiz-payment-input-approver-list.state';
import { GetOrderStoreService } from '@common/services';
import { GetOrderState } from '@common/store';
import { SupportComponent } from '@lib/components/support-class';
import { AswValidators } from '@lib/helpers';
import { ValidationErrorInfo } from '@lib/interfaces';
import { CommonLibService, ModalService } from '@lib/services';
import { OrdersAnaBizGetApproversResponseDataApproversInner } from 'src/sdk-reservation/model/ordersAnaBizGetApproversResponseDataApproversInner';

@Component({
  selector: 'asw-anabiz-payment-input-ticketing-request',
  templateUrl: './anabiz-payment-input-ticketing-request.component.html',
  styleUrls: ['./anabiz-payment-input-ticketing-request.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnabizPaymentInputTicketingRequestComponent extends SupportComponent {
  // 発券要求フォームグループ定義
  public ticketingRequestFormGroup: FormGroup;

  public approverError: ValidationErrorInfo | null = null;
  reload(): void {}
  init(): void {
    this.contractSecName =
      this._common.anaBizContextStoreService.anaBizContextData.authInfo?.companyInfoC?.contractSecName ??
      this._common.anaBizContextStoreService.anaBizContextData.authInfo?.companyInfoC?.contractSecNameEn ??
      '';

    // PNR情報に発券要求コメントが存在する場合、フォームにそれを表示する
    this.subscribeService(
      'AnabizPaymentInputTicketingRequest_GetOrderSubscription',
      this._currentGetOrderSotreService.getGetOrderObservable(),
      (value: GetOrderState) => {
        this.ticketingRequestFormGroup.patchValue({
          ticketingRequestComment: value.data?.anaBizTicketingRequests?.at(-1)?.comment ?? '',
        });
      }
    );

    this._changeDetectorRef.markForCheck();
  }
  destroy(): void {}

  //承認者名
  @Input() currentApprover: string = '';

  /** クレカ情報更新用 */
  @Output()
  updateApproverId: EventEmitter<string> = new EventEmitter<string>();
  public contractSecName: string = '';

  constructor(
    private _common: CommonLibService,
    private _modalService: ModalService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _currentGetOrderSotreService: GetOrderStoreService
  ) {
    super(_common);
    this.ticketingRequestFormGroup = new FormGroup({
      ticketingRequestComment: new FormControl('', []),
    });
  }

  isValid() {
    const validity = this.ticketingRequestFormGroup.valid;
    this.ticketingRequestFormGroup.markAllAsTouched();
    if (!this.currentApprover) {
      this.approverError = {
        errorMsgId: 'E0002',
        params: {
          key: 0,
          value: 'label.approverName',
        },
      };
      this._changeDetectorRef.detectChanges();
      return false;
    }
    this._changeDetectorRef.detectChanges();

    return validity;
  }

  /**
   * 発券要求コメント取得
   */
  getTicketingComment(): string {
    return this.ticketingRequestFormGroup.controls['ticketingRequestComment'].value;
  }

  /**
   *　承認者リストモーダル表示
   */
  async showApproverList() {
    const part = defaultApproverListModalParts();
    part.closeEvent = (value?: OrdersAnaBizGetApproversResponseDataApproversInner) => {
      if (value?.name && value.id) {
        this.currentApprover = value.name;
        this.updateApproverId.emit(value.id);
        this._changeDetectorRef.markForCheck();
      }
    };
    this._modalService.showSubModal(part);
  }
}
